import { isAndroid, isIOS, isMobileOnly, isTablet } from 'react-device-detect';
import { EApiAttendancePlatform } from '@datatype/iyagigo/api-type';
import { EService } from '@datatype/type';

export const OTTERBRICK_KAKAO_JS_KEY = process.env.REACT_APP_OTTERBRICK_KAKAO_JS_KEY;

export const OTTERBRICK_EMAIL = process.env.REACT_APP_OTTERBRICK_EMAIL;

export enum EAdminApiEnv {
  LOCAL = 'local',
  PROD = 'prod',
}

export const ADMIN_API_ENV_STORAGE_KEY = 'admin-api-env';

const ADMIN_API_SERVER: Record<EAdminApiEnv, string> = {
  [EAdminApiEnv.LOCAL]: 'http://localhost:8080',
  [EAdminApiEnv.PROD]: process.env.REACT_APP_ADMIN_API_SERVER || '',
};

const adminApiEnv: EAdminApiEnv =
  localStorage.getItem(ADMIN_API_ENV_STORAGE_KEY) === EAdminApiEnv.PROD ? EAdminApiEnv.PROD : EAdminApiEnv.LOCAL;

export const API_SERVER = window.location.hostname.includes('admin')
  ? ADMIN_API_SERVER[adminApiEnv]
  : process.env.REACT_APP_API_SERVER || 'http://localhost:8080';
// export const SIGNIN_CALLBACK_URL =
//   process.env.REACT_APP_SIGNIN_CALLBACK_URL || 'http://localhost:3000/auth/callback/signin';
// User-Agent 기반 디바이스 감지 (react-device-detect)
// | 변수               | true 조건                                  |
// |--------------------|--------------------------------------------|
// | IS_PHONE           | 휴대폰                                      |
// | IS_TABLET          | 태블릿                                      |
// | IS_IOS             | iOS 기기 (iPhone, iPad)                     |
// | IS_ANDROID         | Android 기기                                |
// | IS_REACT_NATIVE_APP| 앱 WebView 내부 (window.ReactNativeWebView) |
export const IS_PHONE = isMobileOnly;
export const IS_TABLET = isTablet;
export const IS_IYAGIGO_MOBILE_VIEW = IS_PHONE || IS_TABLET;
export const IS_IYAGIGO_DESKTOP_VIEW = !IS_IYAGIGO_MOBILE_VIEW;
export const IS_GRIDGIO_MOBILE_VIEW = IS_PHONE;
export const IS_GRIDGIO_DESKTOP_VIEW = !IS_GRIDGIO_MOBILE_VIEW;
export const IS_IOS = isIOS;
export const IS_ANDROID = isAndroid;
export const IS_REACT_NATIVE_APP = !!window.ReactNativeWebView;

// 접속 플랫폼 판별 (앱 WebView 내부일 때만 ios/android, 그 외는 web)
export const getPlatform = (): EApiAttendancePlatform => {
  if (IS_REACT_NATIVE_APP && IS_IOS) return EApiAttendancePlatform.IOS;
  if (IS_REACT_NATIVE_APP && IS_ANDROID) return EApiAttendancePlatform.ANDROID;
  return EApiAttendancePlatform.WEB;
};

const hostname = window.location.hostname;
const localService = process.env.REACT_APP_SERVICE;
export let SERVICE: EService;

if (hostname.includes('admin')) {
  SERVICE = EService.ADMIN;
} else if (hostname.includes('gridgio')) {
  SERVICE = EService.GRIDGIO;
} else if (hostname.includes('moashelf')) {
  SERVICE = EService.MOASHELF;
} else if (hostname.includes('iyagigo')) {
  SERVICE = EService.IYAGIGO;
} else if (process.env.NODE_ENV === 'test') {
  SERVICE = EService.TEST;
} else if (
  hostname.includes('localhost') ||
  /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
  hostname.includes('ngrok')
) {
  if (localService === EService.GRIDGIO) {
    SERVICE = EService.GRIDGIO;
  } else if (localService === EService.MOASHELF) {
    SERVICE = EService.MOASHELF;
  } else {
    SERVICE = EService.IYAGIGO;
  }
} else {
  throw new Error('service not found');
}
